import { AlertRulesFilterCategory } from '../models';
import { CheckAllCategoryOptionsAction } from '../slice/alerts.types';

export function checkCategoryFiltersOptions(
  selectedFiltersPerCategory: Record<string, Record<string, boolean>>,
  payload: CheckAllCategoryOptionsAction,
) {
  const { categoryKey, options, type } = payload;

  if (type === 'clear') {
    delete selectedFiltersPerCategory[categoryKey as AlertRulesFilterCategory];

    return;
  }

  const selectedFilters = options.reduce((acc, option) => {
    acc[option] = true;

    return acc;
  }, {} as Record<string, boolean>);

  selectedFiltersPerCategory[categoryKey] = selectedFilters;
}
